module.exports = __webpack_public_path__ + "static/media/mob-left.c6be0528.png";